import { render, staticRenderFns } from "./number.vue?vue&type=template&id=4a97eba3&scoped=true"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"
import style0 from "./number.vue?vue&type=style&index=0&id=4a97eba3&lang=css"
import style1 from "./number.vue?vue&type=style&index=1&id=4a97eba3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97eba3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a97eba3')) {
      api.createRecord('4a97eba3', component.options)
    } else {
      api.reload('4a97eba3', component.options)
    }
    module.hot.accept("./number.vue?vue&type=template&id=4a97eba3&scoped=true", function () {
      api.rerender('4a97eba3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowShopManagement/components/number.vue"
export default component.exports